<div class="wound-assessment-container">
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ "loading" | translate }}...</span>
    </div>
    <p class="loading-text">{{ "loading" | translate }}...</p>
  </div>

  <div *ngIf="hasError && !isLoading" class="error-container">
    <i class="fa-solid fa-triangle-exclamation error-icon"></i>
    <p class="error-text">{{ "patientDetail.noData" | translate }}</p>
    <button class="btn btn-primary" (click)="goBack()">
      {{ "backToMenu" | translate }}
    </button>
  </div>

  <ng-container *ngIf="!isLoading && !hasError && patient && wound">
    <app-patient-overview
      [patient]="patient"
      [scores]="scores"
      [latestAssessment]="latestAssessment"
      [showBackButton]="true"
      [selectedWoundParentId]="wound.parentWoundId"
      [selectedWoundStatus]="wound.woundStatus"
      [canCreateFollowUp]="canCreateFollowUp"
      [isWoundActive]="wound?.isActive ?? true"
      (backClick)="goBack()"
    ></app-patient-overview>

    <div class="assessment-layout">
      <div class="left-panel">
        <app-wound-assessment-detail
          [wound]="wound"
          class="d-block h-100"
        ></app-wound-assessment-detail>
      </div>

      <div class="right-panel" [formGroup]="assessmentForm">
        <div class="panel-card">
          <!-- Tab Navigation -->
          <div class="tab-navigation">
            <button
              class="tab-button"
              [class.active]="activeTab === 'model'"
              (click)="switchTab('model')"
            >
              <span>{{
                "patientCreate.woundAssessment.tabs.modelViewer" | translate
              }}</span>
            </button>
            <button
              class="tab-button"
              [class.active]="activeTab === 'documents'"
              (click)="switchTab('documents')"
            >
              <span>{{
                "patientCreate.woundAssessment.tabs.documents" | translate
              }}</span>
            </button>
            <button
              class="tab-button"
              [class.active]="activeTab === 'analysis'"
              (click)="switchTab('analysis')"
            >
              <i class="fa-solid fa-microscope"></i>
              <span>Analiz</span>
              <span
                class="tab-badge"
                *ngIf="wound?.isProcessing"
                title="Analiz devam ediyor"
              ></span>
            </button>
          </div>

          <!-- Model Viewer Tab Content -->
          <div class="tab-content" *ngIf="activeTab === 'model'">
            <div class="model-header">
              <span class="view-label">{{
                "patientCreate.woundAssessment.tabs.modelViewer" | translate
              }}</span>
              <app-select
                formControlName="selectedModel1"
                [items]="models"
                bindLabel="name"
                bindValue="url"
                [clearable]="true"
                style="width: 250px"
              ></app-select>
            </div>

            <div class="viewer-container">
              <app-model-viewer
                [modelUrl]="selectedModel1"
                [existingNotes]="selectedModel1Notes"
                [allowAnnotation]="false"
                [hide2DToolbar]="true"
                [hide3DDeleteButton]="true"
                [woundMetrics]="parsedMetrics"
                (onMarkerCreated)="handleMarkerCreation($event)"
              ></app-model-viewer>
            </div>
          </div>

          <!-- Documents Tab Content -->
          <div
            class="tab-content documents-content"
            *ngIf="activeTab === 'documents'"
          >
            <app-document-manager
              [patientId]="patientId"
              [woundId]="woundId"
              [readOnlyDocumentUpload]="!canUploadDocuments"
            ></app-document-manager>
          </div>

          <!-- Analysis Tab Content -->
          <div
            class="tab-content analysis-content"
            *ngIf="activeTab === 'analysis'"
          >
            <app-wound-analysis-metrics
              [woundId]="woundId"
              [wound]="wound"
            ></app-wound-analysis-metrics>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
